const translation = {
  // Navbar
  nav_hotel_intro: 'About Hotel',
  nav_greeting: 'Greeting',
  nav_about: 'About',
  nav_rooms: 'Rooms',
  nav_services: 'Facilities',
  nav_nearby: 'Nearby',
  nav_refund: 'Refund Policy',
  nav_contact: 'Access',
  nav_support: 'Support',
  nav_reserve: 'Reservation',

  // Hero
  hero_welcome: 'Welcome to Korea · Dongdaemun',
  hero_title: 'YOUNGBIN HOTEL',
  hero_subtitle: 'Welcome to Youngbin Hotel',
  hero_location: 'IN DONGDAEMUN',
  hero_cta_reserve: 'Book Now · Reservation',
  hero_cta_rooms: 'View Rooms',
  hero_slide1_label: 'A Place of Comfort & Rest',
  hero_slide2_label: 'Cozy Guest Rooms',
  hero_slide3_label: 'Clean & Modern Bathrooms',
  hero_slide4_label: 'Prime Location in Dongdaemun',
  hero_slide5_label: 'Youngbin Hotel for Travelers',

  // About
  about_tag: 'WELCOME TO THE YOUNGBIN HOTEL',
  about_title: 'Heart of Dongdaemun,\nYoungbin Hotel',
  about_desc1: 'Youngbin Hotel is located adjacent to the Dongdaemun International Fashion Town in Jung-gu, Seoul. Just a 10-minute walk from Dongdaemun shopping districts, perfect for shopping and sightseeing.',
  about_desc2: 'We offer comfortable rooms and a variety of facilities, with friendly service to make your precious trip even more special.',
  about_stat1_label: 'Concierge Service',
  about_stat2_label: 'Free Wi-Fi',
  about_stat3_label: 'Walk to Dongdaemun',
  about_cta: 'Make a Reservation',

  // Rooms
  rooms_tag: 'ROOM GUIDANCE',
  rooms_title: 'Our Rooms',
  rooms_subtitle: 'Discover the comfortable and cozy rooms at Youngbin Hotel',
  room1_name: 'Single Room',
  room1_desc: 'A cozy and practical room for solo travelers. The perfect base camp for exploring Dongdaemun.',
  room2_name: 'Twin Room',
  room2_desc: 'A room with two single beds, ideal for two travelers. Enjoy a comfortable stay in a spacious and pleasant space.',
  room3_name: 'Double Room',
  room3_desc: 'A room with one double bed, suitable for couples or 1-2 travelers. Provides a cozy and comfortable atmosphere.',
  room4_name: 'Triple Room',
  room4_desc: 'A spacious room with three single beds, perfect for three travelers. Ideal for family trips or small group travel.',
  room5_name: 'Ondol Room',
  room5_desc: 'A room with traditional Korean ondol floor heating. Experience the warm and cozy Korean-style accommodation culture.',
  room6_name: 'Suite Room',
  room6_desc: 'A spacious and luxurious suite room that makes your special trip even more special. Equipped with a bathtub and minibar.',

  // Services
  svc_tag: 'WELCOME TO THE YOUNGBIN HOTEL',
  svc_title: 'SERVICE',
  svc_subtitle: 'Experience the various services provided by Youngbin Hotel',
  svc1_label: 'Wake-up Call',
  svc1_desc: 'We provide wake-up call service at your desired time.',
  svc2_label: '24H Concierge',
  svc2_desc: 'Contact us anytime 24 hours a day if you need assistance.',
  svc3_label: 'Security',
  svc3_desc: 'We guarantee safe accommodation with a thorough security system.',
  svc4_label: 'Free Wi-Fi',
  svc4_desc: 'Free high-speed Wi-Fi is provided in all rooms.',
  svc5_label: 'Sauna',
  svc5_desc: 'You can use the sauna facilities to relieve fatigue.',
  svc6_label: 'Parking',
  svc6_desc: 'We provide convenient parking space.',

  // Reservation
  res_tag: 'RESERVATION',
  res_title: 'Book Now',
  res_subtitle: 'Fill out the form below and we will contact you promptly',
  res_name: 'Full Name',
  res_name_ph: 'John Doe',
  res_phone: 'Phone Number',
  res_phone_ph: '+82-10-0000-0000',
  res_email: 'Email',
  res_checkin: 'Check-in Date',
  res_checkout: 'Check-out Date',
  res_room: 'Room Type',
  res_room1: 'Single Room',
  res_room2: 'Twin Room',
  res_room3: 'Double Room',
  res_room4: 'Triple Room',
  res_room5: 'Ondol Room',
  res_room6: 'Suite Room',
  res_message: 'Message',
  res_message_ph: 'Please enter any additional inquiries. (Max 500 characters)',
  res_submit: 'Send Reservation Inquiry',
  res_submitting: 'Sending...',
  res_success_title: 'Your inquiry has been received!',
  res_success_desc: 'We will contact you as soon as possible.',

  // Contact
  contact_tag: 'WELCOME TO THE YOUNGBIN HOTEL',
  contact_title: 'CONTACT US',
  contact_address_label: 'Address',
  contact_address: '18, Toegyero 56-gil, Jung-gu, Seoul\n(Ssangnim-dong, Youngbin Hotel)',
  contact_phone_label: 'Phone / FAX',
  contact_email_label: 'Email',
  contact_checkinout_label: 'Check-in / Check-out',
  contact_checkin: 'Check-in: 15:00',
  contact_checkout: 'Check-out: 12:00',

  // Footer
  footer_desc: 'Youngbin Hotel adjacent to Dongdaemun International Fashion Town.\nSauna, breakfast, 10 min walk to Dongdaemun shopping.',
  footer_hotel_info: 'Hotel Info',
  footer_support: 'Customer Support',
  footer_lang: 'Language',
  footer_about: 'About',
  footer_rooms: 'Rooms',
  footer_services: 'Facilities',
  footer_contact: 'Access',
  footer_reserve: 'Reservation',
  footer_email_inquiry: 'Email Inquiry',
  footer_phone_inquiry: 'Phone Inquiry',
  footer_copyright: 'Copyright © Youngbin Hotel. All rights reserved. | 18, Toegyero 56-gil, Jung-gu, Seoul',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Use',
};

export default translation;
